export enum PortalVisibility {
    Shop = 'VISIBILITY_SHOP',
    Synergy = 'VISIBILITY_SYNERGY',
    Both = 'VISIBILITY_SHOP_SYNERGY',
}
